import { render, staticRenderFns } from "./VersionReleased.vue?vue&type=template&id=4c3140d0&"
import script from "./VersionReleased.vue?vue&type=script&lang=js&"
export * from "./VersionReleased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports